import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    hasCookies: false,
  },
  reducers: {
    setHasCookie: (state, action) => {
      state.hasCookies = action.payload;
    },
  },
});

export const { setHasCookie } = authSlice.actions;

export default authSlice.reducer;
